export default __webpack_public_path__ + "static/media/ic_kcc_hover_16.bc8fc0d8.svg";